type DiscountRuleValues = {
  isDefaultDiscountEnabled?: boolean;
  lastMinuteNightRoomDiscountRate?: number | null;
  lastMinuteNightRoomDiscountDays?: number | null;
};

export const hasDiscountRule = ({
  isDefaultDiscountEnabled,
  lastMinuteNightRoomDiscountRate,
  lastMinuteNightRoomDiscountDays,
}: DiscountRuleValues) =>
  isDefaultDiscountEnabled === true ||
  (lastMinuteNightRoomDiscountRate !== null &&
    lastMinuteNightRoomDiscountRate !== undefined &&
    lastMinuteNightRoomDiscountDays !== null &&
    lastMinuteNightRoomDiscountDays !== undefined &&
    lastMinuteNightRoomDiscountDays > 0);
